<template>
  <div class="body">
    
      <Headtow  @sou="sou"></Headtow>

      <div id="w-center">
        <div id="Breadcrumb">
          <i class="el-icon-house Breadcrumb-i" ></i>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>产品库</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <!-- 左侧 -->
        <div class="w-products">
          <div id="products_type">
            <el-radio-group v-model="typeid" @change="type" size="medium">
                <el-radio-button label="1" >全部</el-radio-button>
                <el-radio-button v-for="(item, index) in types"  :label="item.id" :key="item.id" >{{item.title}} </el-radio-button>
              </el-radio-group>
              <div class="h-10"></div>
              <el-radio-group v-model="typeids" @change="typetwos" size="medium">
                  <el-radio-button label="1" >全部</el-radio-button>
                  <el-radio-button v-for="(item, index) in typetwo"  :label="item.id" :key="item.id" >{{item.title}} </el-radio-button>
                </el-radio-group>
          </div>
          <ul id="products-content"  v-loading="loading">
              <li v-for="(item, index) in list" :key="item.id">
                <router-link :to="{path:'/ProductsCont',query: {id: item.id}}">
                  <div class="products-content-left">
                      <img :src="item.picurl" alt="" lazy >
                  </div>
                  <div class="products-content-center">
                      <p class="products-content-center-title">{{item.title}}</p>
                      <p class="products-content-center-jianjie ov2">{{item.introduction}}</p>
                      <p class="products-content-center-bq">{{item.money}}</p>
                      <p class="products-content-center-gsmc  ov1">{{item.gsname}}</p>
                  </div>
                  <div class="products-content-right">
                     <el-button>产品咨询</el-button>
                     <el-button>专家帮我挑</el-button>
                  </div>
                  <div class="clear"></div>
                </router-link>
               </li>
          </ul>
          <div class="page">
            <el-pagination
              background
              layout="prev, pager, next"
              :page-size="12"
              @current-change="handleCurrentChange"
              :total="total">
            </el-pagination>
          </div>
        </div>
        <!-- 左侧结束 -->
        <!-- 右侧开始 -->
         <div id="products-right">
             <p class="products-right-title">专家推荐</p>
             <ul class="products-right-ul">
               <li class="ov1" v-for="(item, index) in left" :key="item.id">
                 <router-link  :to="{path:'/ProductsCont',query: {id: item.id}}">
                    {{item.title}}
                </router-link>
               </li>

             </ul>
         </div>
        <!-- 右侧结束 -->
      </div>
       <Foot></Foot>
  </div>

</template>

<script>
import headtow from '@/components/public/headtow.vue';
import foot from '@/components/public/foot.vue'
export default{
  data(){
    return {
      loading:true,
      list:[],
      page:1,
      total:0,
      info:[],
      activeName: 'first',
      ptzc:'',
      tabPosition:'1',
      types:{},
      typeid:'1',
      typeids:'1',
      typetwoid:'1',
      left:{},
      keywords:'',
      typetwo:[],
    }
  },
  components: {
    'Headtow': headtow,  //将别名demo 变成 组件 Demo
     'Foot': foot,

  },
  mounted () {
    this.keywords = this.$route.query.keyword
    var typeid = this.$route.query.typeid
    if(typeid){
      this.typeid = typeid;
    }
    var typetwoid = this.$route.query.typetwoid
    if(typetwoid){
      this.typetwoid = typetwoid
      this.typeids = typetwoid;
    }
    console.log(this.keywords);
    this.recordapi();
  },
  methods:{

    recordapi(){
        var that = this;
        var userid = that.$cookieStore.getCookie('userid');
        that.$api.post("/Products/ProductsIndex",{'typetwoid':that.typetwoid,'type':that.typeid,'page':this.page,'keyword':this.keywords}).then(res => {
          console.log(res);
          that.types= res.type;
          that.typetwo= res.typetwo;
          that.list= res.list.data;
          this.total = res.list.total
          that.left = res.left;
          this.loading = false
        });
    },
    sou(){
     this.keywords = this.$route.query.keyword
     console.log(this.keywords);
      this.recordapi();
    },
    // 分页
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.recordapi();
    },
    // 分类
    type:function(e){
      this.loading = true,
     console.log(e);
     this.keywords = '';
     this.typeid = e;
     this.typetwoid = 1;
     this.typeids = 1;
     this.recordapi();
    },

    typetwos:function(e){
    this.loading = true,
    console.log(e);
    this.keywords = '';
    this.typetwoid = e;
    this.recordapi();
    },



  }

 }
</script>



// WEBPACK FOOTER //
// src/components/Products.vue